import { NavigateOptions } from "react-router-dom"

import { PRODUCT } from "shared/constants/permalinks"
import { useEvent } from "shared/lib/useEvent"

import { getProductType } from "entities/products/lib/getProductType"
import { useNavigateToItem } from "features/navigation/model/useNavigateToItem"

interface ProductPageSearchParams {
  variantKey: string
  configurationKey?: string | null
  dimensioningKey?: string | null
}

export function useNavigateToProduct<T extends string | null>(
  variantKey: T
): T extends string
  ? () => void
  : (payload: ProductPageSearchParams, options?: NavigateOptions) => void
export function useNavigateToProduct<T extends string | null>(variantKey: T) {
  const navigateToItem = useNavigateToItem(variantKey, PRODUCT)

  return useEvent(
    (
      {
        variantKey: nextVariantKey,
        configurationKey: nextConfigurationKey,
        dimensioningKey: nextDimensioningKey
      }: ProductPageSearchParams,
      options?: NavigateOptions
    ) => {
      const params: Record<string, string> = {}

      if (nextVariantKey) {
        params.variantKey = nextVariantKey ?? ""
      }
      if (nextConfigurationKey) {
        params.configurationKey = nextConfigurationKey ?? ""
      }
      if (nextDimensioningKey) {
        params.dimensioningKey = nextDimensioningKey ?? ""
      }

      navigateToItem({
        id: getProductType(nextVariantKey),
        params,
        options
      })
    }
  )
}
